// extracted by mini-css-extract-plugin
module.exports = {"favoriteStatus":"style_favoriteStatus__yVY5h","svg":"style_svg__imBst","favorite":"style_favorite__K1lzh","unFavorite":"style_unFavorite__FG_Wz"};